import { MAP_LIST_API_URL, INFOGRAPHIC_LIST_API_URL } from "../constants/urls";
import { FETCH_DISTRICT_MAP_LIST, FETCH_DISTRIST_INFOGRAPHICS_LIST } from "../constants/actionType";

function fetchMapsOnDistrict(url) {
    url = url && url.length > 0 ? url : MAP_LIST_API_URL;
    if (url) {
        return {
            type: FETCH_DISTRICT_MAP_LIST,
            request: {
                url: url
            }
        };
    }
}

function fetchInfographyOnDistrict(url) {
    url = url && url.length > 0 ? url : INFOGRAPHIC_LIST_API_URL;
    if (url) {
        return {
            type: FETCH_DISTRIST_INFOGRAPHICS_LIST,
            request: {
                url: url
            }
        };
    }
}

export { fetchMapsOnDistrict, fetchInfographyOnDistrict };
